// PasswordTextField.tsx
import { TextField, FormControl, styled } from '@mui/material';

// Создаем стилизованный компонент TextField
export const PasswordTextField = styled(TextField)({
  // Применяем стили через Emotion/Styled-Components
  '& .MuiInputBase-input[type="password"]::-webkit-contacts-auto-fill-button, & .MuiInputBase-input[type="password"]::-webkit-textfield-decoration-container': {
    visibility: 'hidden',
    pointerEvents: 'none',
  },
  '& ::-ms-reveal': {
    display: 'none',
  },
});